import { axios } from '@/assets/common/axios'
import '@/assets/common/theme/index.css'
import tools from '@/assets/common/tools'
import mixin from '@/mixins/mixins'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.mixin(mixin)
Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$tools=tools
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
